<div class="container-principal grid-container">
  <div class="container-faixa-vertical col-4" aria-hidden="true"></div>

  <div class="conteudo-autenticacao col-8">
    <div class="container-logo" aria-hidden="true"></div>

    <div class="container-formulario-login">
      <form [formGroup]="loginForm" (ngSubmit)="autenticar()">

      <div>

        <input matInput type="text" placeholder="Usuário" id="usuario" formControlName="usuario"/>

        @if (loginForm.get('usuario')?.invalid && (loginForm.get('usuario')?.dirty || loginForm.get('usuario')?.touched)) {
        <div class="validation-error">
          @if (loginForm.get('usuario')?.hasError('required')) {
          <div>O campo usuário é obrigatório.</div>
          }

        </div>
        }

      </div>

      <div>
        <input matInput type="password" placeholder="Senha" id="senha" formControlName="senha" />
        @if (loginForm.get('senha')?.invalid && (loginForm.get('senha')?.dirty || loginForm.get('senha')?.touched)) {
        <div class="validation-error">

          @if (loginForm.get('senha')?.hasError('required')) {
          <div>O campo senha é obrigatório.</div>

          } @else if (loginForm.get('senha')?.hasError('minlength')) {
          <div>A senha deve ter pelo menos 8 caracteres.</div>

          }
        </div>
        }
      </div>

       <div class="recaptcha-container">
          <ngx-turnstile
            formControlName="captchaToken"
            siteKey="{{captchaKey}}"
            (resolved)="onResolved($event)"
            (errored)="onError()">
          </ngx-turnstile>

          @if (loginForm.get('captchaToken')?.invalid && loginForm.get('captchaToken')?.touched) {
          <div class="validation-error">
            @if (loginForm.get('captchaToken')?.hasError('required')) {
            <div>O captcha é obrigatório.</div>
            }
          </div>
          }

        </div>


        <div class="container-botao-entrar">
          <button matButton class="botao-primario botao-entrar" type="submit">ENTRAR</button>
        </div>
      </form>
    </div>

    <div class="container-aviso-cookies">
      <p>
        <b>Aviso de Cookies</b>
      </p>

      <p>
        Utilizamos cookies para oferecer melhor experiência e melhorar o desempenho.
        Ao utilizar este site, você concorda com o uso de cookies.
      </p>
    </div>
  </div>


</div>
